import React from "react";
import { LeftArrowIcon } from "../../shared/svg/LeftArrowIcon/LeftArrowIcon";
import { RightArrowIcon } from "../../shared/svg/RightArrowIcon/RightArrowIcon";
import { StyledHorizontalScoreboardNavigator } from "./StyledHorizontalScoreboardNavigator";

export const HorizontalScoreboardNavigatorTypes = {
  left: "left",
  right: "right",
};

export const HorizontalScoreboardNavigator = ({
  innerRef,
  position = "",
  onClick = () => null,
}) => {
  if (
    position !== HorizontalScoreboardNavigatorTypes.left &&
    position !== HorizontalScoreboardNavigatorTypes.right
  ) {
    return null;
  }

  return (
    <StyledHorizontalScoreboardNavigator
      ref={innerRef}
      onClick={onClick}
      className={`mls-c-horizontal-scoreboard__navigator--${position}`}
    >
      {position == HorizontalScoreboardNavigatorTypes.right ? (
        <RightArrowIcon width={5} height={10} maskId="horizontal-scoreboard__navigator"/>
      ) : (
        <LeftArrowIcon width={5} height={10} />
      )}
    </StyledHorizontalScoreboardNavigator>
  );
};
